export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["ROOM_JOINING"] = "ROOM_JOINING";
    ACTIONS["ROOM_JOINED"] = "ROOM_JOINED";
    ACTIONS["ROOM_RECONNECTING"] = "ROOM_RECONNECTING";
    ACTIONS["ROOM_RECONNECTED"] = "ROOM_RECONNECTED";
    ACTIONS["ROOM_DISCONNECTED"] = "ROOM_DISCONNECTED";
    ACTIONS["OT_VIDEO_ELEMENT_CREATED"] = "OT_VIDEO_ELEMENT_CREATED";
    ACTIONS["OT_PUBLISHER_INITIALIZING"] = "OT_PUBLISHER_INITIALIZING";
    ACTIONS["OT_PUBLISHER_READY"] = "OT_PUBLISHER_READY";
    ACTIONS["OT_PUBLISHER_FAILED"] = "OT_PUBLISHER_FAILED";
    ACTIONS["OT_VIDEO_PUBLISHER_FAILED"] = "OT_VIDEO_PUBLISHER_FAILED";
    ACTIONS["OT_VIDEO_PUBLISHER_SUCCESS"] = "OT_VIDEO_PUBLISHER_SUCCESS";
    ACTIONS["OT_AUDIO_PUBLISHER_FAILED"] = "OT_AUDIO_PUBLISHER_FAILED";
    ACTIONS["OT_AUDIO_PUBLISHER_SUCCESS"] = "OT_AUDIO_PUBLISHER_SUCCESS";
    ACTIONS["OT_PUBLISHER_CONNECTING"] = "OT_PUBLISHER_CONNECTING";
    ACTIONS["OT_PUBLISHER_CONNECTED"] = "OT_PUBLISHER_CONNECTED";
    ACTIONS["OT_PUBLISHER_DISCONNECTED"] = "OT_PUBLISHER_DISCONNECTED";
    ACTIONS["OT_SUBSCRIBER_CONNECTING"] = "OT_SUBSCRIBER_CONNECTING";
    ACTIONS["OT_SUBSCRIBER_CONNECTED"] = "OT_SUBSCRIBER_CONNECTED";
    ACTIONS["OT_SUBSCRIBER_DISCONNECTED"] = "OT_SUBSCRIBER_DISCONNECTED";
    ACTIONS["UPDATE_PEERS"] = "UPDATE_PEERS";
    ACTIONS["ADD_PEERS"] = "ADD_PEERS";
    ACTIONS["ADD_PEER"] = "ADD_PEER";
    ACTIONS["REMOVE_PEER"] = "REMOVE_PEER";
    ACTIONS["OT_STREAM_CREATED"] = "OT_STREAM_CREATED";
    ACTIONS["OT_STREAM_DESTROYED"] = "OT_STREAM_DESTROYED";
    ACTIONS["HMS_TRACK_ADDED"] = "HMS_TRACK_ADDED";
    ACTIONS["AUDIO_TOGGLED"] = "AUDIO_TOGGLED";
    ACTIONS["AUDIO_VOLUME_CHANGED"] = "AUDIO_VOLUME_CHANGED";
    ACTIONS["VIDEO_TOGGLED"] = "VIDEO_TOGGLED";
    ACTIONS["LEFT_ROOM"] = "LEFT_ROOM";
})(ACTIONS || (ACTIONS = {}));
//# sourceMappingURL=types.js.map